import { getPacks } from '../peijian/all'

export default {
  name: 'igs-22',
  // 图文
  imageText: [
    // 主图1
    {
      type: 'formwork2',
      img: 'http://igstech.com.cn/resources/buguang/product-igs-22/IGS-22-1.jpg',
    },
    {
      type: 'formwork9',
      list: [
        {
          id: 'a-1',
          text: '1、Powerful grow lights, talllamp arm, highwater capacity, large grow deck, and detachable trellis',
        },
      
        { id: 'a-3', text: '2、20W LED grow light for patent spectrum,optimallighting' },
        {
          id: 'a-4',
          text: '3 up to 19" each layer of grow height so you can grow big plants and features alarger bowl to hold more water than the base Harvest',
        },
  
        { id: 'a-6', text: '4、Easy, automatic reminders for water &plant food' },
      ],
    },
    // 配件 TODO:
    {
      type: 'formwork5',
      packs: getPacks([
    
        { id: 'accessories-17', num: 1 },
      ]),
    },
    // 参数
    {
      type: 'formwork6',
      specifications: [
        { id: '2-1', name: 'Product Specifications:', value: '500x228x665(H)mm' },
        { id: '2-2', name: 'Product Weight:', value: '3.0kg' },
        { id: '2-3', name: 'Adapter Specifications Input:', value: '100V-240V/50-60HZ' },
        { id: '2-4', name: 'Output:', value: '5V' },
        { id: '2-5', name: 'Colour:', value: 'White' },
        { id: '2-6', name: 'Power:', value: '20W' },
        { id: '2-7', name: 'Color box SIe:', value: '440x230x230mm' },
        { id: '2-8', name: 'Outer box SIZE:', value: '480×460x475mm' },
      ],
    },
    // 主图3
    {
      type: 'formwork2',
      img: 'http://igstech.com.cn/resources/buguang/product-igs-22/IGS-gaungpu-zhuanli.png',
    },
  ],
}
